import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SharedConfirmData } from './confirmation-data.model';

@Component({
    templateUrl: './confirmation-modal.template.html'
})
export class SharedConfirmationModalComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: SharedConfirmData) {}
}
